import { currentEventId, EventJournalModalQueries } from '@entities/eventJournal/model/queries';
import { useNuqsQueryState } from '@shared/hooks';

export const useEventJournalModal = (onCloseModalCb?: () => void) => {
    const { state: modalMode, setState: setModalMode } = useNuqsQueryState(
        EventJournalModalQueries.queryName
    );
    const { state: currentEventIdQueryState, setState: setCurrentEventId } =
        useNuqsQueryState(currentEventId);

    const isCreateMode = modalMode === EventJournalModalQueries.queryCreate;
    const isEditMode = modalMode === EventJournalModalQueries.queryEdit;
    const isOpen = isCreateMode || isEditMode;

    const handleClose = () => {
        void setModalMode(null);
        onCloseModalCb?.();

        if (isEditMode) {
            void setCurrentEventId(null);
        }
    };

    return {
        currentEventIdQueryState,
        isCreateMode,
        isEditMode,
        isOpen,
        modalMode,
        handleClose,
    };
};
